// --------------------------------------------------------------------------------
// Preloader & Pagination Exports
export { PreloaderComponent } from './shared/preloader/preloader.component';
export { PaginationComponent } from './pagination/pagination.component';

// --------------------------------------------------------------------------------
// Materialize Exports
export { MaterializeModule } from 'angular2-materialize';

// --------------------------------------------------------------------------------
// Chart.js Exports
export { ChartModule } from 'angular2-chartjs';

// --------------------------------------------------------------------------------
// Loading Exports
export { LoadingComponent } from './shared/loading/loading.component';
export { LoadingService } from './shared/loading/loading.service';

// --------------------------------------------------------------------------------
// Authorize Status Exports
export { AuthorizedStatusService } from './services/authorized-status.service';

// --------------------------------------------------------------------------------
// Chart Widget Exports
export { ChartWidgetContainerComponent } from './shared/chart-widget-container/chart-widget-container.component';
export { ChartWidgetComponent } from './shared/chart-widget-container/chart-widget/chart-widget.component';
export { ChartWidgetContainerService } from './shared/chart-widget-container/chart-widget-container.service';
export { ChartWidgetService } from './shared/chart-widget-container/chart-widget/chart-widget.service';

// --------------------------------------------------------------------------------
// Data Widget Exports
export { DataWidgetComponent } from './shared/data-widget-container/data-widget/data-widget.component';
export { DataWidgetContainerComponent } from './shared/data-widget-container/data-widget-container.component';
export { DataWidgetService } from './shared/data-widget-container/data-widget/data-widget.service';
export { DataWidgetContainerService } from './shared/data-widget-container/data-widget-container.service';

// --------------------------------------------------------------------------------
// List Widget Exports
export { ListWidgetComponent } from './shared/list-widget-container/list-widget/list-widget.component';
export { ListWidgetContainerComponent } from './shared/list-widget-container/list-widget-container.component';
export { ListWidgetContainerService } from './shared/list-widget-container/list-widget-container.service';
export { ListWidgetService } from './shared/list-widget-container/list-widget/list-widget.service';

// --------------------------------------------------------------------------------
// Note Widget Exports
export { NoteWidgetContainerService } from './shared/note-widget-container/note-widget-container.service';
export { NoteWidgetService } from './shared/note-widget-container/note-widget/note-widget.service';
export { NoteWidgetContainerComponent } from './shared/note-widget-container/note-widget-container.component';
export { NoteWidgetComponent } from './shared/note-widget-container/note-widget/note-widget.component';
export { NoteService } from './services/note-service';

// --------------------------------------------------------------------------------
// Activity Widget Exports
export { ActivityWidgetContainerComponent } from './shared/activity-widget-container/activity-widget-container.component';
export { ActivityWidgetComponent } from './shared/activity-widget-container/activity-widget/activity-widget.component';
export { ActivityWidgetContainerService } from './shared/activity-widget-container/activity-widget-container.service';
export { ActivityWidgetService } from './shared/activity-widget-container/activity-widget/activity-widget.service';

// --------------------------------------------------------------------------------
// Address Exports
export { AddressComponent } from './shared/address-modal/address.component';
export { AddressService } from './shared/address-modal/address.service';

// --------------------------------------------------------------------------------
// Non Allocated Sim Exports
export { NonAllocatedSimComponent } from './sims/non-allocated-sims/non-allocated-sim.component';
export { NonAllocatedSimService } from './sims/non-allocated-sims/non-allocated-sim.service';

// --------------------------------------------------------------------------------
// Sheet Exports
export { SheetComponent } from './shared/sheet-export-import/sheet-export-import.component'
export { SheetService } from './shared/sheet-export-import/sheet.service';

// --------------------------------------------------------------------------------
// Populate Form Exports
export { PopulateFormService } from './services/populate-form';

// --------------------------------------------------------------------------------
// Notifcation Exports
export { NotificationHandlerService } from './shared/notifications/notification-handler.service';

// --------------------------------------------------------------------------------
// Resports Exports
export { ReportService } from './services/reports.service';

// --------------------------------------------------------------------------------
// Pipe Exports
export { ReversePipe } from './pipes/reverse.pipe';
export { SortTrafficPipe } from './pipes/date-sort.pipe';

// --------------------------------------------------------------------------------
// Chat Bot Exports
export { AssistantComponent } from './assistant/assistant.component';

// --------------------------------------------------------------------------------
// QR Code Generator Exports
export { QRCodeGeneratorComponent } from './units/qr-code-generator/qr-code-generator.component';

// --------------------------------------------------------------------------------
// Control Refresh Provider
export { ControlStateRefreshService } from './units/units-program-control/unit-controls/control-state-refresh.service';


// WEBPACK FOOTER //
// ./angularApp/app/index.ts